import { Box, Flex, Grid, Image } from '@chakra-ui/react';
import { InputField } from '../../../inputs/InputField/inputField';

import { useFormikContext } from 'formik';
import { CartridgeModel } from 'src/components/common/CartridgeModel/cartridgeModel';
import { CartridgeInfoType } from '../SetCartridgeType/setCartridgeType';
import { useTranslation } from 'react-i18next';

import { TwoColumn } from '../../containers/TwoColumn/twoColumn';
import { LeftColumn } from '../../containers/TwoColumn/leftColumn';
import { RightColumn } from '../../containers/TwoColumn/rightColumn';
import { FormSectionHeading } from 'src/components/common/texts/FormSectionHeading/formSectionHeading';
import { FormSectionAddon } from 'src/components/common/texts/FormSectionAddon/formSectionAddon';
import { placeholderUrl } from 'src/config';
import UsefulLinks from "../../../texts/UsefulLinks/useLinks";

export const SetCoverImage = ({ selectedCartridge }: { selectedCartridge: CartridgeInfoType }) => {
	const { values } = useFormikContext();
	const { t } = useTranslation();

	return (
		<TwoColumn>
			<LeftColumn>
				<FormSectionHeading label={t('form.steps.setCover.label')}>
					{t('form.steps.setCover.heading')}
				</FormSectionHeading>

				<InputField
					label={t('form.fields.coverURL')}
					name="media.cover"
					placeholder={placeholderUrl('cover.png')}
					leftText="URL"
					warningText="16:9"
				/>

				<FormSectionAddon>
					<UsefulLinks actionText={t('onboarding.links.graphicSpecs')} file='assets/docs/lightpaper.pdf'/>
				</FormSectionAddon>
			</LeftColumn>
			<RightColumn>
				<Flex
					h="470px"
					alignItems="center"
					justifyContent="center"
				>
					<CartridgeModel
						glareColor={selectedCartridge.color}
						color={selectedCartridge.type}
						image={(values as any).media.cover}
					/>
				</Flex>
			</RightColumn>
		</TwoColumn>
	);
};
